export const PatientEncounterDetailsStyle = {
  container: {
    flex: 1,
    flexDirection: 'column',
    overflowY: 'auto',
    gap: 18,
    padding: '14px',
  },
};
